<template>
  <PSAreasActive />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
